import * as React from 'react';

import { INotification, IActivityType } from '@models';
import {
    classNames,
    InputText,
    NotificationsBox,
    useForm,
    useTranslation,
    ValidationBuilder,
} from '@components';

import './WorkForm.css';

export interface IProps {
    data?: IActivityType;
    workId: number;
    footer?: any;
    notifications: INotification[];
    onChange?: Function;
    onSubmit: Function;
}

export const validateActivity = (data: IActivityType) => {
    return ValidationBuilder.create(data).notEmpty('name').build();
}

export const isValid = (data: IActivityType) => {
    return Object.keys(validateActivity(data)).length == 0;
}

export function ActivityTypeForm(props: IProps) {
    const { t } = useTranslation();

    const form = useForm<IActivityType>({
        initialValues: {
            id: props.data?.id ?? 0,
            name: props.data?.name ?? '',
            workId: props.workId,
            subcontractor: props.data?.subcontractor ?? false,
        },
        validate: validateActivity,
        onSubmit: (data: IActivityType) => {
            props.onSubmit(data);
            return {ok: true};
        },
        onChange: props.onChange,
    });

    return <div>
        <form onSubmit={form.handleSubmit}
            className='p-fluid'>
            <div className='c md pd g-30'>
                {form.floatField('name', t('Name'), () =>
                    <InputText
                    id='name'
                    type= 'text'
                    value={form.values.name}
                    onChange={form.handleChange}
                    autoFocus
                    className={classNames({ 'p-invalid': !form.isFormFieldValid('name') })}/>)}
            </div>
            <div className='errors-container'>
                {form.errorBox()}
                <NotificationsBox notifications={props.notifications} />
            </div>
            {props.footer != undefined && props.footer}
        </form>
    </div>
}